export const style = {
  wrapper: {
    border: `rgba(0,0,0,0.1) 1px solid`
    // padding: 0
  },
  header: {
    fontSize: `20px`,
    fontWeight: `400`,
    // color: `black`,
    padding: `15px 20px`,
    borderBottom: `rgba(0,0,0,0.07) 1px solid`
  },
  footer: {
    padding: `5px 15px 10px 15px`
    // borderTop: `rgba(0,0,0,0.07) 1px solid`
  },
  link: {
    fontSize: `12px`,
    fontWeight: 400,
    color: `#A94545`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Remind/style/box.js